import { cn } from '@/context/global/utils/cn';

export type IconHeartProps = {
  className?: string;
  size?: number;
  fill?: string;
};

export default function IconHeart({ className = '', size = 32 }: IconHeartProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M16.826 27.7466C16.3727 27.9066 15.626 27.9066 15.1727 27.7466C11.306 26.4266 2.66602 20.92 2.66602 11.5866C2.66602 7.46663 5.98602 4.1333 10.0793 4.1333C12.506 4.1333 14.6527 5.30663 15.9993 7.11997C17.346 5.30663 19.506 4.1333 21.9193 4.1333C26.0127 4.1333 29.3327 7.46663 29.3327 11.5866C29.3327 20.92 20.6927 26.4266 16.826 27.7466Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
